import { createContext, useContext } from 'react';
import { Role } from 'api/RolesAPI';
import { CombinedRole } from '../types';

type RolesContextType = {
  combinedRoles: CombinedRole[];
  currentRole: CombinedRole | undefined;
  isLoadingRoles: boolean;
  refetchRoles: () => void;
  rolesById: { [key: string]: Role };
};

const defaultState = {
  combinedRoles: [],
  currentRole: undefined,
  isLoadingRoles: false,
  refetchRoles: () => undefined,
  rolesById: {},
};

export const RolesContext = createContext<RolesContextType>(defaultState);

export const useRolesContext = () => useContext<RolesContextType>(RolesContext);
